import {useEffect} from "react";
import Section from "../components/Section";
import {BottomNavigator} from "../components/Navbar";

const PrivacyPage = () => {
    useEffect(() => {
        return () => {
            document.body.style.backgroundColor = null;
        };
    }, []);

    return (
        <div className={'Page PrivacyPage'}>
            <Section className={'PrivacySection'} id={"privacy"}>
                <h1>Privacy Policy</h1>
                
                <div className={'PrivacyContent'}>
                    <div className={'PrivacyContent__section'}>
                        <p>
                            Lavita's mission is to help individuals take full control of their health data. Users will benefit by unlocking the value of their health data, to receive personalized health and wellness information, and to participate in paying research and studies.
                        </p>
                    </div>

                    <div className={'PrivacyContent__section'}>
                        <p>
                            By agreeing to this consent, you give permission to Lavita to retrieve and encrypt your health data from Epic and other EHR providers. Your data will be immediately encrypted on your device browser, using a private encryption key that is generated from your chosen password.
                        </p>
                    </div>

                    <div className={'PrivacyContent__section'}>
                        <p>
                            Lavita never stores your unencrypted data. Only users themselves can access their data by login into Lavita platform and using their private encryption key, generated by your password. No entity, including Lavita itself, can decrypt your data without your own explicit consent.
                        </p>
                    </div>

                    <div className={'PrivacyContent__section'}>
                        <p>
                            If you choose to contribute your data to Lavita platform, Lavita will collect certain de-identified meta data about you to allow researchers to ask for your participation, with your permission, in paid studies through Lavita platform.
                        </p>
                    </div>

                    <div className={'PrivacyContent__section'}>
                        <p>
                            For further information please contact privacy@lavita.ai
                        </p>
                    </div>
                </div>
            </Section>

            <BottomNavigator next={{
                to: '/',
                title: 'Home'
            }}/>
        </div>
    )
};

export default PrivacyPage;
